import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect } from 'react';
import { useForm } from '../FormContext';
import { useDebounce } from '@/common/hooks/debounce/useDebounce';

export const useUnqCode = (disabled, value) => {

  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();
  const rsrc = useRsrc();
  const { entityDef } = useEntityMgr();
  const { assignErrorState, errorStates } = useForm();

  // This value is only updated if the user stops typing for 500 milliseconds
  const debouncedValue = useDebounce(value, 500);

  useEffect(() => {
    if (!disabled) {
      const expr = ExprUtils.whereParams('code', value);
      rsrc.one(module, entity, { expr }).then(entityObj => {
        // In order to avoid conflicts with the error state that is computed by useFormField(), we assign this error state to its own key
        assignErrorState('unqCodeCheck', entityObj !== null ? `Another ${entityDef.displayName} has this code` : null);
      })
    }

    return () => {
      assignErrorState('unqCodeCheck', null);
    }
  }, [debouncedValue])

  return { unqCodeErrorState: errorStates.unqCodeCheck };
}